var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    rx: 2,
    fill: "#F5F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1997 2.72314L21.2871 2.71161L24.1831 2.73631C24.1886 2.73631 24.1941 2.72314 24.1997 2.72314Z",
    fill: "#CD4045"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1313 19.7421L13.5768 4.53237C13.8038 3.53758 15.0663 2.73109 16.0697 2.71061L9.38559 2.70874C8.3766 2.70874 7.08296 3.5246 6.85223 4.53237L3.40673 19.7421C3.38583 19.8348 3.37419 19.9259 3.36719 20.0148V20.297C3.43463 21.0237 3.9908 21.5527 4.79008 21.5648H11.5147C10.522 21.5498 9.9036 20.7387 10.1313 19.7421Z",
    fill: "#D8232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2879 2.74662L16.1104 2.70874C16.0973 2.70874 16.0838 2.72191 16.0703 2.73344L21.2879 2.74662Z",
    fill: "#2D4C6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2648 19.7421L21.7093 4.53239C21.9363 3.54497 23.1825 2.7441 24.1831 2.7135L21.2871 2.71163L16.0695 2.71063C15.0661 2.73111 13.8037 3.5376 13.5767 4.53239L10.1312 19.7421C9.90345 20.7388 10.5218 21.5499 11.5145 21.5648H19.6485C18.6553 21.5499 18.0378 20.7388 18.2648 19.7421Z",
    fill: "#0067A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2025 2.71246C24.195 2.71246 24.1895 2.71346 24.184 2.71346C23.1834 2.74405 21.9372 3.54493 21.7102 4.53234L18.2657 19.7421C18.0387 20.7387 18.6562 21.5498 19.6494 21.5648H27.3013C28.2795 21.5165 29.2301 20.7249 29.4532 19.7485L32.8978 4.53884C33.1284 3.53194 32.4961 2.71434 31.4862 2.71434L24.2025 2.71246Z",
    fill: "#009294"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionpay);
export default __webpack_public_path__ + "static/media/unionpay.f2fdc15e01e8e00d8c24928dc676e074.svg";
export { ForwardRef as ReactComponent };